/**
 * Primary function of security settings is to enable MFA for admin/charities
 * 
 * For charities, it is managed in a modal, whilst for admins it is on the main page
 * Therefore, there's some minor variations to cover both ways this class can be initated
 */

import Fetcher      from "Scripts/common/fetcher";
import Form         from "Scripts/common/form";
import MfaEnterCode from "Scripts/common/mfa-enter-code";

export default class SecuritySettings {
	constructor() {
		this.ui = {
			modal: $("#modal-security-settings"),
		};

		// Form could be on the page, or could be in a modal

		const triggerBtn = $("#btn-security-settings-trigger");

		if(triggerBtn.length) {
			triggerBtn.on("click", this.showModal.bind(this));
		} else {
			this.setupSettingsForm();
		}
	}

	showModal(e) {
		console.log("SecuritySettings.showModal()", $(e.currentTarget).data('amount'));

		new Fetcher({
			callback: this.setupSettingsForm.bind(this),
			element:  "#fetcher-security-settings",
			modal:    this.ui.modal,
			trigger:  $(e.currentTarget)
		});
	}

	setupSettingsForm() {
		console.log("SecuritySettings.setupSettingsForm()");

		const formEl = $("#form-security-settings");

		if(!formEl.length) {
			return;
		}

		new Form({
			callback: this.postSettingsForm.bind(this),
			form:     formEl,
		});

		new MfaEnterCode({
			form: $("#form-verify"),
			callback: this.postVerifyForm.bind(this),
		});

		this.ui.settingsContainer = $("#security-settings-container");
		this.ui.verifyContainer = $("#verify-mfa-container");
		this.ui.successContainer = $("#verify-mfa-success-container");
	}

	postSettingsForm(response) {
		console.log("SecuritySettings.postSettingsForm", response);

		const requiresMfaVerification = response.payload.requiresMfaVerification;

		if(requiresMfaVerification) {
			this.ui.settingsContainer.collapse("hide");
			this.ui.verifyContainer.collapse("show");
		} else if(this.ui.modal.length) {
			this.ui.modal.modal('hide');
		} else {
			window.location = "/dashboard";
		}
	}

	postVerifyForm(resp) {
		console.log("SecuritySettings.postVerifyForm", resp);

		if(!resp.success) {
			return;
		}

		if(this.ui.modal.length) {
			this.ui.verifyContainer.collapse("hide");
			this.ui.successContainer.collapse("show");
		} else {
			window.location = "/dashboard";
		}
	}
}